




































import VueOptions from '@utils/VueOptions'

settings = 
  name: 'SponsorResourceListItem'

  vue:
    props: ['item', 'rowSize', 'actions', 'selected', 'backgroundColor']

    computed:
      stats: ->
        @ctxStats @item

      formattedDealIDs: ->
        campaign = @ctxCampaign @item
        offer = @ctxOffer @item
        @compact(@flatten([campaign.deal_ids, offer.deal_ids])).join(', ')

    methods:
      shouldExpandCollumn: (size) ->
        return true if @rowSize >= 2 && size == 'MEDIUM'
        return true if @rowSize == 3 && size == 'LARGE'

export default VueOptions.vue settings
